import createReactComponent from '../createReactComponent';
export default createReactComponent(
  'chevron-down-left',
  'IconChevronDownLeft',
  [['path', { d: 'M8 8v8h8', key: 'svg-0' }]],
);
